import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './EditVibeLayout.css';
import editvibelogo1 from '../assets/Editvibelogo1.svg';
import defaultAvatar from '../assets/default-avatar.png'; 
import vidIcon from '../assets/vid.svg'; // The default center prompt icon
import aistars from '../assets/aistars.svg'; // The icon for "Nails Video"
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { GoGear } from 'react-icons/go';
import { BsTicketPerforated } from "react-icons/bs";  // for Video tutorials
import { IoTicketOutline } from "react-icons/io5";      // for My plan
import { LuLogOut } from "react-icons/lu";
import { RiScissorsCutLine } from "react-icons/ri";
import { PiFilmSlateLight } from "react-icons/pi";        
import { IoMdDownload } from "react-icons/io";
import { FaRegTrashCan } from "react-icons/fa6";      // for Logout
import { TfiVideoClapper } from 'react-icons/tfi';
import useTypingEffect from '../hooks/useTypingEffect'
import editvibe95tutorial from '../assets/editvibe95tutorial.mp4';
import editvibecuttutorial from '../assets/editvibecuttutorial.mp4';
import Tour from './Tour';
import {
  updateDoc,
  increment,
  doc,
  serverTimestamp,
  collection,
  addDoc,
  onSnapshot,
  query,
  where,
  deleteDoc
} from "firebase/firestore";
import { AiOutlineHistory } from "react-icons/ai";
import { db, storage } from '../auth';  // Adjust this path as needed
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

/** Helper function to verify file is a video and under 2 minutes. */
function checkVideoFile(file) {
  return new Promise((resolve) => {
    if (!file.type.startsWith('video/')) {
      resolve({ valid: false, error: 'Not a video file.' });
      return;
    }
    const videoEl = document.createElement('video');
    videoEl.preload = 'metadata';
    videoEl.onloadedmetadata = () => {
      window.URL.revokeObjectURL(videoEl.src);
      const duration = videoEl.duration;
      if (duration <= 600) {
        resolve({ valid: true, duration });
      } else {
        resolve({ valid: false, error: 'Video is longer than 10 minutes.' });
      }
    };
    videoEl.onerror = () => {
      resolve({ valid: false, error: 'Could not load video metadata.' });
    };
    videoEl.src = URL.createObjectURL(file);
  });
}

function EditVibeLayout({ user, userData, logout }) {
  const [runTour, setRunTour] = useState(false);
  useEffect(() => {
    if (userData?.hasSeenTour === false) {
      setRunTour(true);
    }
  }, [userData]);
  const messages = [
    'EditVibe crafts your video masterpiece now',
  'Our AI sculpts your footage to perfection!',
  'Production quality review is underway now!',
  'Almost done—finalizing your stunning video',
  'Please relax and grab coffee, be back soon',
  'Your edit has departed our creative studio',
  'Inspecting frames now for flawless quality',
  'Tailoring your video to your exact vision!',
  'Adding the final touches to your edit now!',
  'Your polished video will be ready shortly!'
  ];
  
  const [msgIndex, setMsgIndex] = useState(0);
  const { text: typingText, isAnimating } = useTypingEffect(messages[msgIndex]);
  
  useEffect(() => {
    if (!isAnimating) {
      const t = setTimeout(() => {
        setMsgIndex((msgIndex + 1) % messages.length);
      }, 1000);
      return () => clearTimeout(t);
    }
  }, [isAnimating, msgIndex]);
  // ========== Model Dropdown ==========
  const [isModelMenuOpen, setIsModelMenuOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState('m1');
  const navigate = useNavigate();

  const handleModelClick = () => {
    setIsUploadOpen(false);
    setIsVideoOverlayOpen(false);
    setSelectedVideo(null);
    setIsModelMenuOpen(!isModelMenuOpen);
  };

  const selectModel = (model) => {
    console.log('Model Selected:', model); // Add this line to check if the function is being triggered
    setSelectedModel(model);
    setIsModelMenuOpen(false);

      // If the user selects 'toolBETA', navigate to the new tool page
      if (model === 'editvibeTool') {
        console.log('Navigating to /editvibetool');
    navigate("/editvibetool");  // Make sure this route is set in your routing config
  }
};
  

  // ========== Avatar Dropdown ==========
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const handleAvatarClick = () => setIsUserMenuOpen(!isUserMenuOpen);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  // ========== Settings Overlay ==========
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [settingsTab, setSettingsTab] = useState('general');
  const openSettings = (tab = 'general') => {
    setIsSettingsOpen(true);
    setIsUserMenuOpen(false);
    setSettingsTab(tab);
  };
  const closeSettings = () => setIsSettingsOpen(false);
  const handleTabClick = (tab) => setSettingsTab(tab);

  // ========== Manage Plan Overlay ==========
  const [isManagePlanOpen, setIsManagePlanOpen] = useState(false);
  const openManagePlan = () => {
    setIsManagePlanOpen(true);
    setIsSettingsOpen(false);
  };
  const closeManagePlan = () => setIsManagePlanOpen(false);

  // NEW: Function to handle plan purchase via Stripe Checkout Session
  const handlePurchasePlan = async (plan) => {
    try {
      const response = await fetch("https://us-central1-editvibe-90968.cloudfunctions.net/createCheckoutSession", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          plan: plan,
          userId: user.uid,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        // Redirect to the checkout session URL provided by the backend
        window.location.href = data.checkoutUrl;
      } else {
        alert("Error: " + data.error);
      }
    } catch (err) {
      console.error("Error purchasing plan:", err);
      alert("Error purchasing plan, please try again later.");
    }
  };

  // ========== Videos & Upload Flow ==========
  const FOUR_GB = 4 * 1024 * 1024 * 1024;
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isDescribeOpen, setIsDescribeOpen] = useState(false);

  const [videoFile, setVideoFile] = useState(null);
  const [videoDuration, setVideoDuration] = useState(0);
  const [videoPreview, setVideoPreview] = useState('');
  const [uploadError, setUploadError] = useState('');

  const [videoDescription, setVideoDescription] = useState('');
  const [useMusic, setUseMusic] = useState(false);
  const [useSFX, setUseSFX] = useState(false);

  // Cost Calculation: <= 60s => 1000 credits, otherwise 2000
  const minutes = Math.ceil(videoDuration / 60);
const cost = Math.min(minutes * 1000, 10000);

  // ========== Persistent Uploaded Videos ==========
  const [persistedVideos, setPersistedVideos] = useState([]);

  // Listen for user videos in Firestore
  useEffect(() => {
    if (user) {
      const videosQuery = collection(db, "videos");
      const userVideosQuery = query(videosQuery, where("userId", "==", user.uid));
      const unsubscribe = onSnapshot(userVideosQuery, (snapshot) => {
        const vids = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        setPersistedVideos(vids);
      });
      return () => unsubscribe();
    }
  }, [user]);

  const handleTourFinish = async () => {
    // stop showing
    setRunTour(false);
    // mark in Firestore so they never see it again
    await updateDoc(doc(db, "users", user.uid), { hasSeenTour: true });
  };

    // ——— GOD-MODE STATE ———
    const [uploadDisabled, setUploadDisabled] = useState(false);
    const [showKillModal,   setShowKillModal]   = useState(false);

    // ——— SUBSCRIBE TO GOD-MODE FLAG ———
  useEffect(() => {
    const cfg = doc(db, "settings", "godMode");
    const unsub = onSnapshot(cfg, snap => {
      setUploadDisabled(snap.exists() ? snap.data().uploadDisabled : false);
    });
    return unsub;
  }, []);

  // Overlay states
  const [isVideoOverlayOpen, setIsVideoOverlayOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Kebab menu for final videos
  const [menuOpenFor, setMenuOpenFor] = useState(null);
  const [videoToDelete, setVideoToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showUploadMoreModal, setShowUploadMoreModal] = useState(false);
  const [lastUploadedName, setLastUploadedName] = useState('');
  const [isReedit, setIsReedit] = useState(false);
  const [showInsufficient, setShowInsufficient] = useState(false);

    // ─── VIDEO TUTORIALS STATE ───
    const [tutorialMenuOpen,     setTutorialMenuOpen]     = useState(false);
    const [tutorialModalOpen,    setTutorialModalOpen]    = useState(false);
    const [tutorialToPlay,       setTutorialToPlay]       = useState(null);
  

  // Notification state – shows when a new video is added
  const [queueNotification, setQueueNotification] = useState({ videoId: null, show: false });

  // "Nails Video" State (static placeholder removed)
  const [isNailsVideoOpen, setIsNailsVideoOpen] = useState(false);
  const [isNailsVideoDeleted, setIsNailsVideoDeleted] = useState(false);

  // New state: isSubmitting indicates that the video is being uploaded
  const [isSubmitting, setIsSubmitting] = useState(false);
  

  // ========== New: Function to handle download of the video file ==========
  const handleDownload = async (url, filename) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename || 'video.mp4';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download error", err);
    }
  };
  const handleReedit = () => {
    if (!selectedVideo) return;
  
    // Set a flag if you need to distinguish re-edit mode (optional)
    setIsReedit(true);
  
    // Pre-populate the description with the original file's name.
    // Ensure that when you first uploaded the file you saved these values,
    // for example as `originalVideoURL` and `originalVideoName` in Firestore.
    const originalName = selectedVideo.originalVideoName || 'Original File';
    setVideoDescription(`Re-Edit: ${originalName}`);
  
    // Set the video preview to the original video URL.
    // This will display the thumbnail (or the video) from the original file.
    setVideoPreview(selectedVideo.originalVideoURL);

     // 2) Load its duration so cost recalculates correctly
  const vid = document.createElement('video');
  vid.preload = 'metadata';
  vid.src = selectedVideo.originalVideoURL;
  vid.onloadedmetadata = () => {
    setVideoDuration(vid.duration);
  };
  vid.onerror = () => {
    console.warn('Could not load metadata for re-edit duration');
    setVideoDuration(0);
  };
  
    // Close the upload modal if open and open the description panel.
    setIsUploadOpen(false);
    setIsDescribeOpen(true);
  };

  // ========== Functions ==========
  const handleMenuToggle = (key, e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPosition({ top: rect.top, left: rect.right });
    setMenuOpenFor((prev) => (prev === key ? null : key));
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setVideoToDelete(null);
  };
// Helper function to extract file name from a Firebase Storage URL.
const getFirebaseFileNameFromUrl = (url) => {
  try {
    const decodedUrl = decodeURIComponent(url);
    // The URL generally contains '/o/' before the path. E.g.,
    // https://firebasestorage.googleapis.com/v0/b/your-bucket/o/finalVideos%2Fb2rzC50bb5VMtApdpfgrQk3nmCI3?alt=media&token=...
    const parts = decodedUrl.split('/o/');
    if (parts.length < 2) return null;
    // parts[1] looks like "finalVideos/b2rzC50bb5VMtApdpfgrQk3nmCI3?alt=media&token=..."
    const filePart = parts[1].split('?')[0];
    // If your folder structure is "finalVideos/{user.uid}/{fileName}" then split by "/" and take the last part:
    const fileParts = filePart.split('/');
    return fileParts[fileParts.length - 1];
  } catch (error) {
    console.error("Error extracting file name from URL:", error);
    return null;
  }
};

// When the user clicks "Upload more" button:
const handleUploadMore = () => {
  // Open the upload-more confirmation modal
  setShowUploadMoreModal(true);
};

// When the user clicks Cancel in the modal:
const handleCancelUploadMore = () => {
  setShowUploadMoreModal(false);
};

// When the user clicks Continue in the modal:
const handleContinueUploadMore = () => {
  // Check for the video name from all possible fields
  const fileName =
    selectedVideo.videoName ||
    selectedVideo.finalVideoName ||
    selectedVideo.originalVideoName ||
    'Unknown File';

  const continuationText = `Continuation of file ${fileName}`;
  setVideoDescription(continuationText);

  // Close the modal and send the user to the upload section.
  setShowUploadMoreModal(false);
  openUploadModal(true); // Pass true if you want to keep the pre-written description
};


const handleConfirmDelete = async () => {
  if (!videoToDelete) return;
  try {
    // Determine the folder and file name.
    let firebaseFileName = videoToDelete.firebaseFileName; // This might be undefined for final videos.
    let folder = `videos/${user.uid}`;
    
    // If the video is final (has a finalVideoURL), assume it's in the "finalVideos" folder.
    if (videoToDelete.finalVideoURL) {
      folder = `finalVideos/${user.uid}`;
      // If firebaseFileName is not provided in the document, extract it from the URL.
      if (!firebaseFileName) {
        firebaseFileName = getFirebaseFileNameFromUrl(videoToDelete.finalVideoURL);
      }
    }
    
    if (!firebaseFileName) {
      throw new Error("Firebase file name is not available.");
    }
    
    // Build the storage path:
    const filePathToDelete = `${folder}/${firebaseFileName}`;
    const storageRefToDelete = ref(storage, filePathToDelete);
    
    // Attempt deletion from Storage:
    await deleteObject(storageRefToDelete);
    
    // Now delete the Firestore document. Adjust the collection name if needed.
    await deleteDoc(doc(db, "videos", videoToDelete.id));
    
    // Update local state to remove the deleted video.
    setPersistedVideos(prev =>
      prev.filter((video) => video.id !== videoToDelete.id)
    );
    setSelectedVideo(null);
    setIsVideoOverlayOpen(false);
  } catch (error) {
    console.error("Error confirming deletion:", error);
    alert("Error deleting video. Please try again.");
  } finally {
    setShowDeleteModal(false);
    setVideoToDelete(null);
  }
};


  const handleDeleteVideo = (vidId, e) => {
    e.stopPropagation();
    // Optionally remove from Firestore
    setPersistedVideos((prev) => prev.filter((video) => video.id !== vidId));
    setMenuOpenFor(null);
  };

  const getVideoByMenuKey = (menuKey) => {
    const videoId = menuKey.replace("final-", "");
    return persistedVideos.find((video) => video.id === videoId);
  };  

  const handleDeleteNailsVideo = (e) => {
    e.stopPropagation();
    setIsNailsVideoOpen(false);
    setMenuOpenFor(null);
    setIsNailsVideoDeleted(true);
  };

  const openUploadModal = (keepDescription = false) => {
    // Close other overlays
    setIsVideoOverlayOpen(false);
    setIsModelMenuOpen(false);
    setSelectedVideo(null);
  
    // Open the upload modal and clear values (unless told to keep the description)
    setIsUploadOpen(true);
    setIsDescribeOpen(false);
    setVideoFile(null);
    setVideoDuration(0);
    setVideoPreview('');
    setUploadError('');
    if (!keepDescription) {
      setVideoDescription('');
    }
    setUseMusic(false);
    setUseSFX(false);
    setIsNailsVideoOpen(false);
  };

  const closeUploadFlow = () => {
    setIsUploadOpen(false);
    setIsDescribeOpen(false);
    setVideoFile(null);
    setVideoDuration(0);
    setVideoPreview('');
    setUploadError('');
    setVideoDescription('');
    setUseMusic(false);
    setUseSFX(false);
  };

  const proceedToDescribe = () => {
    setIsUploadOpen(false);
    setIsDescribeOpen(true);
  };

  const dropHandler = async (e) => {
    e.preventDefault();
    if (uploadDisabled) {
      setShowKillModal(true);
      return;
    }
    if (!e.dataTransfer.files[0]) return;
    const file = e.dataTransfer.files[0];
    await handleVideoFile(file);
  };

  const handleFileChange = async (e) => {
    if (uploadDisabled) {
      setShowKillModal(true);
      return;
    }
    if (!e.target.files[0]) return;
    const file = e.target.files[0];
    await handleVideoFile(file);
  };

  const handleVideoFile = async (file) => {
    setUploadError('');

    // 1) Enforce 2 GB size limit
    if (file.size > FOUR_GB) {
      setUploadError('File is larger than 4 GB. Please select a smaller file.');
      return;
    }

    const { valid, duration, error } = await checkVideoFile(file);
    if (!valid) {
      setUploadError(error || 'Invalid file.');
      return;
    }
    setVideoFile(file);
    setVideoDuration(duration || 0);
    setVideoPreview(URL.createObjectURL(file));
    proceedToDescribe();
  };

  // Before uploading, check if the user has enough credits
  const handleSubmitDescription = async () => {
    // If neither a new file nor a selected video is present, alert the user.
    if (!videoFile && !selectedVideo) {
      alert("No video file selected.");
      return;
    }
    
    if (userData?.credits < cost) {
      setShowInsufficient(true);
      return;
    }
    
    setIsSubmitting(true);
    try {
      let uniqueFileName, storageRef, downloadURL;
      
      if (videoFile) {
        // Normal upload flow:
        uniqueFileName = `${user.uid.slice(0, 8)}_${Date.now().toString(36)}.mp4`;
        storageRef = ref(storage, `videos/${user.uid}/${uniqueFileName}`);
        await uploadBytes(storageRef, videoFile);
        downloadURL = await getDownloadURL(storageRef);
      } else if (selectedVideo) {
        // Re-edit mode: use original file info
        downloadURL = selectedVideo.originalVideoURL; 
        uniqueFileName = selectedVideo.originalVideoName; 
        // Optionally, you could skip re-uploading if your intent is to simply re-use the original file.
      }
      
      // Add a new Firestore document with the video details
      const videosCol = collection(db, "videos");
      const videoRef   = await addDoc(videosCol, {
        userId: user.uid,
        description: videoDescription,
        music: useMusic,
        soundEffects: useSFX,
        videoURL: downloadURL,
        createdAt: serverTimestamp(),
        videoName: videoFile ? videoFile.name : selectedVideo.originalVideoName,
        originalVideoURL: videoFile ? downloadURL : selectedVideo.originalVideoURL,
        originalVideoName: videoFile ? videoFile.name : selectedVideo.originalVideoName,
        cost: cost
      });
      
      // 2) atomically deduct credits AND record the cost+video so your rules allow it
const userDocRef = doc(db, "users", user.uid);
await updateDoc(userDocRef, {
  credits:           increment(-cost),
  lastDeductedVideo: videoRef.id,
  lastDeductedCost:  cost
});
      
      setQueueNotification({ videoId: null, show: true });
      setTimeout(() => {
        setQueueNotification({ videoId: null, show: false });
      }, 3000);
      
      closeUploadFlow();
    } catch (error) {
      console.error("Error uploading video or saving metadata:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  

  const handleVideoItemClick = (vid) => {
    setIsUploadOpen(false);
    setIsModelMenuOpen(false);
    setSelectedVideo(vid);
    // Store the name in a dedicated state variable
    setLastUploadedName(vid.videoName || vid.originalVideoName || '');
    setIsVideoOverlayOpen(true);
  };

  const closeVideoOverlay = () => {
    setIsVideoOverlayOpen(false);
    setSelectedVideo(null);
  };

  const handleNailsVideoClick = () => {
    if (isNailsVideoOpen) {
      setIsNailsVideoOpen(false);
    } else {
      setIsVideoOverlayOpen(false);
      setSelectedVideo(null);
      setIsNailsVideoOpen(true);
    }
  };
  const openTutorialMenu   = () => setTutorialMenuOpen(true);
  const closeTutorialMenu  = () => setTutorialMenuOpen(false);
 
  const showTutorial = (which) => {
    setTutorialToPlay(which);
    setTutorialModalOpen(true);
    setTutorialMenuOpen(false);
    setIsUserMenuOpen(false); 
  };
 
  const closeTutorialModal = () => {
    setTutorialModalOpen(false);
    setTutorialToPlay(null);
  };

  return (
    <>
      <Tour run={runTour} onFinish={handleTourFinish} />
    <div className="editvibe-layout" onClick={() => setMenuOpenFor(null)}>
      {/* ===== SIDEBAR ===== */}
      <aside className="ev-sidebar">
        <div className="sidebar-logo">
          <img src={editvibelogo1} alt="Edit Vibe Logo" className="ev-logo-img" />
        </div>

        <div className="sidebar-section">
          <h2 className="videos-title">Videos</h2>
          <button className="sidebar-add" onClick={openUploadModal}>+</button>
        </div>

        {/* Render persisted videos from Firestore */}
        {persistedVideos.map((vid, index) => {
          const isFinal = !!vid.finalVideoURL;
          const displayName = isFinal ? vid.finalVideoName || "Untitled.mp4" : "New Video";
          const itemClass = isFinal ? "video-item nails-video-item" : "video-item";
          const isSelected = (selectedVideo && selectedVideo.id === vid.id && isVideoOverlayOpen);

          return (
            <div
              key={vid.id}
              className={`${itemClass} ${isSelected ? 'selected' : ''}`}
              onClick={() => handleVideoItemClick(vid)}
              style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
            >
             {isFinal ? (
  <>
    {/* Icon on the left */}
    <div className="nails‑stars‑icon">
  <div className="nails‑orbit nails‑orbit1">
    <div className="nails‑star" style={{ "--size": "16px" }}></div>
  </div>
  <div className="nails‑orbit nails‑orbit2">
    <div className="nails‑star" style={{ "--size": "12px" }}></div>
  </div>
  <div className="nails‑orbit nails‑orbit3">
    <div className="nails‑star" style={{ "--size": "10px" }}></div>
  </div>
</div>

    {/* Video info in the middle */}
    <div className="video-info">
      <div className="video-name">{displayName}</div>
      <div className="video-status">Ready, click to watch</div>
    </div>

    {/* Three-dot menu button on the right */}
    <div
      className="video-dots"
      style={{ marginLeft: 'auto' }}
      onClick={(e) => {
        e.stopPropagation();
        handleMenuToggle(`final-${vid.id}`, e);
      }}
    >
      •••
    </div>

    {/* Pop-up menu with Download and Delete options */}
    {menuOpenFor === `final-${vid.id}` && (
      <div
      className="video-menu-outside"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: 'fixed',
        top: menuPosition.top,
        left: menuPosition.left,
        transform: 'translate(0, -50%)',
        zIndex: 9999,
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        padding: '8px',
        minWidth: '80px'
      }}
      >
        <div
          className="menu-download"
          onClick={(e) => {
            e.stopPropagation();
            const video = getVideoByMenuKey(`final-${vid.id}`);
if (video) {
  const url  = video.finalVideoURL  || video.videoURL;
  const name = video.finalVideoName || video.videoName;
  handleDownload(url, name);
}
            setMenuOpenFor(null);
          }}
          style={{ marginBottom: '8px', cursor: 'pointer' }}
        >
         <IoMdDownload style={{ color: '#000', marginRight: '4px' }} />
  Download
</div>
        <div
          className="delete-button"
          onClick={(e) => {
            e.stopPropagation();
            const video = getVideoByMenuKey(`final-${vid.id}`);
            if (video) {
              setVideoToDelete(video);
              setShowDeleteModal(true);
            }
            setMenuOpenFor(null);
          }}
        >
          <FaRegTrashCan style={{ marginRight: '4px', color: '#e33' }} />
          <span style={{ color: '#e33' }}>Delete</span>
        </div>
      </div>
    )}
  </>
) : (
  <>
    <div className="spinner" />
    <div className="video-info">
      <div className="video-name">{vid.videoName}</div>
      <div className="video-status">
        {vid.status || "Preparing..."}
      </div>
    </div>
  </>
)}


              {/* Notification bubble appears on the last video if notification flag is true */}
              {queueNotification.show && index === persistedVideos.length - 1 && (
                <div className="queue-notification">
                  <IoCheckmarkCircleOutline className="checkmark-icon" />
                  <span>Added to queue</span>
                </div>
              )}
            </div>
          );
        })}
      </aside>

      {/* ===== MAIN AREA ===== */}
      <div className="ev-main">
        <header className="ev-header">
          <div className="ev-header-left">
            <div className="ev-app-name" onClick={handleModelClick}>
              EditVibe-95 <span className="dropdown-arrow">▾</span>
            </div>
            {isModelMenuOpen && (
              <div className="model-dropdown">
                <div className="model-title">Model</div>
                <div className="model-option" onClick={() => selectModel('m1')}>
                  <div className="model-info">
                    <div className="model-name">
                      EditVibe-95 <span className="beta-badge">Research Preview</span>
                    </div>
                    <div className="model-desc">
                    upload, describe, and let EditVibe-95 handle the full edit, no manual work
                    </div>
                  </div>
                  {selectedModel === 'm1' && <div className="checkmark">✓</div>}
                </div>
                <div className="model-option model-disabled" onClick={() => selectModel('m2')}>
                  <div className="model-info">
                    <div className="model-name">EditVibe-DOS</div>
                    <div className="model-desc">
                    The next‑gen EditVibe‑95—same full‑edit AI, up to 50% faster processing (under development)
                    </div>
                  </div>
                  {selectedModel === 'm2' && <div className="checkmark">✓</div>}
                </div>
                <div className="model-option" onClick={() => selectModel('editvibeTool')}>
                <div className="model-info">
                 <div className="model-name">
                 EditVibe-CUT <span className="beta-badge">BETA</span>
        </div>
        <div className="model-desc">
        remove video sections easily using simple prompts
              </div>
             </div>
             {selectedModel === 'editvibeTool' && (
    <div className="checkmark">✓</div>
  )}
             </div>
                <div className="model-option model-disabled" onClick={() => selectModel('m2')}>
                  <div className="model-info">
                    <div className="model-name">EditVibe-CUT-2</div>
                    <div className="model-desc">
                    Vision‑powered scene removal—cut based on what you see (under development)
                    </div>
                  </div>
       {selectedModel === 'editvibeTool' && <div className="checkmark">✓</div>}
            </div>
              </div>
            )}
          </div>
          <div className="ev-header-right">
            <button className="create-btn" onClick={openUploadModal}>+ Create</button>
            <img
              src={user?.photoURL ? user.photoURL : defaultAvatar}
              alt="Profile"
              className="user-avatar"
              onClick={handleAvatarClick}
              style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
            />
            {isUserMenuOpen && (
  <div className="user-menu">
    <div className="menu-item" onClick={() => openSettings('general')}>
      <GoGear className="menu-icon" />
      <span>Settings</span>
    </div>

    {/* Video Tutorials */}
    <div
  className="menu-item tutorial-parent"
  onClick={() => setTutorialMenuOpen(open => !open)}
>
  <BsTicketPerforated className="menu-icon" />
  <span>Video tutorials</span>

  {tutorialMenuOpen && (
  <div className="tutorial-dropdown">
    <div
      className="menu-item"
      onClick={() => {
        showTutorial("95");
        setTutorialMenuOpen(false);    // also closes the parent menu
      }}
    >
      <PiFilmSlateLight className="menu-icon" />
      <span>EditVibe‑95</span>
    </div>
    <div
      className="menu-item"
      onClick={() => {
        showTutorial("cut");
        setTutorialMenuOpen(false);
      }}
    >
      <RiScissorsCutLine className="menu-icon" />
      <span>EditVibe‑CUT</span>
    </div>
  </div>
)}
</div>

<div className="menu-item" onClick={() => openSettings('plan')}>
  <IoTicketOutline className="menu-icon" />
  <span>My plan</span>
</div>
<hr />
<div className="menu-item logout-btn" onClick={logout}>
  <LuLogOut className="menu-icon" />
  <span>Logout</span>
</div>
  </div>
)}

          </div>
        </header>
        <main className="ev-body">
          {isNailsVideoOpen ? (
            <div className="nails-video-wrapper">
              <div className="nails-video-player">
                {selectedVideo && selectedVideo.finalVideoURL ? (
                  <video
                    src={selectedVideo.finalVideoURL}
                    controls={false}              
                    autoPlay={false}
                    style={{ width: "100%" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.target.paused ? e.target.play() : e.target.pause();
                    }}
                  />
                ) : (
                  <div className="loading-circle" />
                )}
              </div>
              <div className="nails-video-buttons">
                <button className="reedit-button">Re-Edit</button>
                <button
                  className="download-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownload(
                      selectedVideo.finalVideoURL,
                      selectedVideo.finalVideoName || "video.mp4"
                    );
                  }}
                >
                  Download
                </button>
              </div>
            </div>
          ) : (
            <div className="no-videos-container">
              <img src={vidIcon} alt="Video icon" className="no-videos-icon" />
              <p className="no-videos-text">
                Create your first edit by uploading your video file in the{' '}
                <span className="upload-link" onClick={openUploadModal}>
                  Upload
                </span>{' '}
                section
              </p>
            </div>
          )}
        </main>
      </div>

      {/* ===== OVERLAY: SETTINGS, MANAGE PLAN, UPLOAD, DESCRIBE ===== */}
      {isSettingsOpen && (
        <div className="overlay">
          <div className="settings-modal">
            <div className="settings-left">
              <h2>Settings</h2>
              <div className={`settings-nav-item ${settingsTab === 'general' ? 'active' : ''}`}
                   onClick={() => handleTabClick('general')}>
                <GoGear className="menu-icon" />
                General
              </div>
              <div className={`settings-nav-item ${settingsTab === 'plan' ? 'active' : ''}`}
                   onClick={() => handleTabClick('plan')}>
                <IoTicketOutline className="menu-icon" />
                My plan
              </div>
            </div>
            <div className="settings-right">
              {settingsTab === 'general' && (
                <>
                  <h2>General</h2>
                  <div className="settings-field">
                    <span className="settings-label">Username</span>
                    <span className="settings-value">{user?.displayName || "N/A"}</span>
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Email</span>
                    <span className="settings-value">{user?.email || "N/A"}</span>
                  </div>
                </>
              )}
              {settingsTab === 'plan' && (
                <>
                  <h2>{userData?.plan ? userData.plan.toUpperCase() : "FREE"}</h2>
                  <div className="settings-field">
                    <span className="settings-label">Credits</span>
                    <span className="settings-value">
                      {userData?.credits !== undefined ? userData.credits : "Loading..."}
                    </span>
                  </div>
                  <div className="settings-desc">
                    
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Max Video Duration</span>
                    <span className="settings-value">10mins</span>
                  </div>
                  <div className="settings-desc">
                    Maximum length of the video clip uploaded to EditVibe-95
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Max Resolution</span>
                    <span className="settings-value">1920×1080</span>
                  </div>
                  <div className="settings-field">
                    <span className="settings-label">Max Size File</span>
                    <span className="settings-value">4GB</span>
                  </div>
                </>
              )}
              <div className="settings-buttons">
                <button className="manage-plan-btn" onClick={openManagePlan}>
                  Manage plan
                </button>
                <button className="done-btn" onClick={closeSettings}>Done</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isManagePlanOpen && (
        <div className="overlay">
          <div className="manage-plan-modal">
            <button className="close-manage-btn" onClick={closeManagePlan}>×</button>
            <h2 className="manage-title">Upgrade your plan</h2>
            <div className="plans-container">
              <div className="plan-card">
                <h3>Free</h3>
                <p className="plan-price">$0 <span>/ month</span></p>
                <p className="plan-desc">Explore how AI can help you edit your videos</p>
                <button className="current-plan-button" disabled>Your Current Plan</button>
                <ul className="plan-features">
                  <li>Access to EditVibe-95</li>
                  <li>Access to EditVibe-CUT</li>
                  <li>1,150 credits</li>
                </ul>
              </div>
              <div className="plan-card plus-selected">
                <div className="plan-header">
                  <h3>Plus</h3>
                  <span className="plan-badge">POPULAR</span>
                </div>
                <p className="plan-price">$20 <span>/ month</span></p>
                <p className="plan-desc">Let AI start editing your videos and saving your time</p>
                
                <button
  className={
    userData.plan === 'plus'
      ? 'current-plan-button'
      : 'plan-action-button plus-btn'
  }
  disabled={userData.plan === 'plus'}
  onClick={
    userData.plan === 'plus'
      ? undefined
      : () => handlePurchasePlan('plus')
  }
>
  {userData.plan === 'plus' ? 'Your Current Plan' : 'Get Plus'}
</button>
                <ul className="plan-features">
                <li>Access to EditVibe-95</li>
                <li>Access to EditVibe-CUT</li>
                  <li>2,000 credits</li>
                </ul>
              </div>
              <div className="plan-card">
                <h3>Pro</h3>
                <p className="plan-price">$100 <span>/ month</span></p>
                <p className="plan-desc">
                  Take your video editing production to the next level with EditVibe pro
                </p>
                <button
  className={
    userData.plan === 'pro'
      ? 'current-plan-button'
      : 'plan-action-button black-btn'
  }
  disabled={userData.plan === 'pro'}
  onClick={
    userData.plan === 'pro'
      ? undefined
      : () => handlePurchasePlan('pro')
  }
>
  {userData.plan === 'pro' ? 'Your Current Plan' : 'Get Pro'}
</button>
                <ul className="plan-features">
                <li>Access to EditVibe-95</li>
                <li>Access to EditVibe-CUT</li>
                  <li>10,000 credits</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {isUploadOpen && (
        <div className="overlay">
          <div className="upload-modal">
            <div className="upload-header">
              <h2>Upload Video</h2>
              <button className="close-btn" onClick={closeUploadFlow}>×</button>
            </div>
            <div
              className="upload-body"
              onDragOver={(e) => e.preventDefault()}
              onDrop={dropHandler}
            >
              <div className="upload-icon">⬆</div>
              <p>Drag and drop video files to upload</p>
              <input
                type="file"
                accept="video/*"
                id="fileInput"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              <button
                className="select-files-btn"
                onClick={() => document.getElementById('fileInput').click()}
              >
                Select files
              </button>
              {/* New message about file length */}
              <p style={{ marginTop: "8px", fontSize: "0.7rem", color: "#666" }}>
              EditVibe currently supports single uploads only and files up to 10 minutes in length
              </p>
              {uploadError && <p className="error-msg">{uploadError}</p>}
            </div>
          </div>
        </div>
      )}

      {isDescribeOpen && !isSubmitting && (
        <div className="overlay">
          <div className="describe-modal new-describe-modal">
            {/* Close Button */}
            <button className="close-btn" onClick={closeUploadFlow}>×</button>

            {/* Title */}
            <h2 className="describe-modal-title">Tell EditVibe about your video</h2>
            <p className="describe-modal-subtitle"> Briefly explain what needs tweaking.</p>

            <div className="describe-modal-content">
              {/* Left side: text area + editing preferences */}
              <div className="describe-left">
                <label htmlFor="videoDesc" className="desc-label">Quick summary</label>
                <textarea
                  id="videoDesc"
                  className="desc-textarea"
                  placeholder="This video is for an ad showing my product"
                  value={videoDescription}
                  maxLength={280}
                  onChange={(e) => setVideoDescription(e.target.value)}
                />
                <div className="char-count">
                  {videoDescription.length} / 280
                  </div>
                <div className="editing-preferences">
                  <h3 className="preferences-title">Select editing preferences</h3>
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={useMusic}
                      onChange={() => setUseMusic(!useMusic)}
                    />
                    <div>
                      <strong>Music</strong>
                      <p>Do you want background music in this video?</p>
                    </div>
                  </label>
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={useSFX}
                      onChange={() => setUseSFX(!useSFX)}
                    />
                    <div>
                      <strong>Sound Effects</strong>
                      <p>Do you want sound effects in this video?</p>
                    </div>
                  </label>
                  <label className="checkbox-label disabled-option">
                    <input type="checkbox" disabled />
                    <div>
                      <strong>Graphics</strong>
                      <p>EditVibe currently does not offer advanced graphics.</p>
                    </div>
                  </label>
                  <label className="checkbox-label disabled-option">
                    <input type="checkbox" disabled />
                    <div>
                      <strong>Captions</strong>
                      <p>EditVibe currently does not offer captions.</p>
                    </div>
                  </label>
                </div>
                {/* ——— Express (disabled) ——— */}
                <label
  className="checkbox-label disabled-option express-option"
  title="This service is currently not available"
>
  <input type="checkbox" disabled />
  <div className="express-text">
    <strong>Express</strong>
    <p>Ready in 6 hours</p>
  </div>
</label>
              </div>
              {/* Right side: video preview + cost */}
              <div className="describe-right">
                <div className="video-preview-container">
                  {videoPreview ? (
                    <video
                      src={videoPreview}
                      width="200"
                      controls={false}
                      style={{ backgroundColor: '#000' }}
                    />
                  ) : (
                    <div className="video-placeholder" />
                  )}
                </div>
                <p className="cost-info">This edit will cost: <strong>{cost} credits</strong></p>
              </div>
            </div>


            {/* Bottom Submit Button */}
            <button className="submit-btn describe-submit" onClick={handleSubmitDescription}>
              SUBMIT
            </button>
          </div>
        </div>
      )}

      {isSubmitting && (
        <div className="overlay">
          <div className="loading-modal">
            <div className="loading-indicator">
              <div className="spinner"></div>
              <p>Uploading video...</p>
            </div>
          </div>
        </div>
      )}

{showDeleteModal && videoToDelete && (
  <div className="overlay" onClick={handleCancelDelete}>
    <div
      className="delete-confirm-modal"
      onClick={(e) => e.stopPropagation()} 
    >
      <h2 style={{ marginBottom: "8px", fontSize: "1rem", fontWeight: "600" }}>
      Delete this file?
      </h2>
      <p style={{ marginBottom: "16px", fontSize: "0.95rem", color: "#333" }}>
      You're about to permanently delete  <strong>{videoToDelete.videoName}</strong>.
        <br />
        This action can’t be undone.
      </p>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <button
          className="cancel-btn"
          onClick={handleCancelDelete}
          style={{
            backgroundColor: "#f0f0f0",
            color: "#555",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            cursor: "pointer"
          }}
        >
          Cancel
        </button>
        <button
          className="confirm-delete-btn"
          onClick={handleConfirmDelete}
          style={{
            backgroundColor: "#e33",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}
{showUploadMoreModal && (
  <div className="overlay" onClick={handleCancelUploadMore}>
    <div
      className="confirmation-modal"
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "16px",
        width: "300px",
        margin: "0 auto"
      }}
    >
      <h2 style={{ marginBottom: "8px", fontSize: "1rem", fontWeight: "600" }}>
        Upload next segment?
      </h2>
      <p style={{ marginBottom: "16px", fontSize: "0.95rem", color: "#333" }}>
        Upload next allows you to upload the next 2 minutes of the same video.
        Would you like to continue?
      </p>
      <div className="modal-buttons" style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <button
          className="cancel"
          onClick={handleCancelUploadMore}
          style={{
            backgroundColor: "#f0f0f0",
            color: "#555",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            cursor: "pointer"
          }}
        >
          CANCEL
        </button>
        <button
          className="continue"
          onClick={handleContinueUploadMore}
          style={{
            backgroundColor: "#e33",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            padding: "8px 16px",
            cursor: "pointer"
          }}
        >
          CONTINUE
        </button>
      </div>
    </div>
  </div>
)}

{isVideoOverlayOpen && selectedVideo && (
  <div
    className="video-black-container"
    onClick={closeVideoOverlay}
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    <div className="video-black-box">
      {selectedVideo.finalVideoURL ? (
        <div className="nails-video-wrapper">
          <div className="nails-video-player">
            <video
              src={selectedVideo.finalVideoURL}
              controls
              style={{ width: "100%" }}
              onClick={e => {
                e.stopPropagation();
                e.target.paused ? e.target.play() : e.target.pause();
              }}
            />
          </div>
          <div className="nails-video-buttons">
            <button
              className="reedit-button"
              onClick={e => {
                e.stopPropagation();
                handleReedit();
              }}
            >
              Re-Edit
            </button>
            <button
              className="overlay-download-button"
              onClick={e => {
                e.stopPropagation();
                handleDownload(
                  selectedVideo.finalVideoURL,
                  selectedVideo.finalVideoName || "video.mp4"
                );
              }}
            >
              Download
            </button>
            <button
              className="upload-more-btn"
              onClick={e => {
                e.stopPropagation();
                handleUploadMore();
              }}
            >
              Upload more
            </button>
          </div>
        </div>
      ) : (
        <div className="loading-circle" />
      )}
    </div>

    {!selectedVideo.finalVideoURL && (
  <div className="typing-wrapper">
    <div className="ai-stars loading-icon">
      <div className="orbit orbit1">
        <div className="star" style={{ "--size": "16px" }} />
      </div>
      <div className="orbit orbit2">
        <div className="star" style={{ "--size": "12px" }} />
      </div>
      <div className="orbit orbit3">
        <div className="star" style={{ "--size": "10px" }} />
      </div>
    </div>
    <div className="typing-text">
      {typingText}
      <span
        className="caret"
        style={{ visibility: isAnimating ? "visible" : "hidden" }}
      />
    </div>
  </div>
)}
  </div>
)}

{showInsufficient && (
  <div className="overlay" onClick={() => setShowInsufficient(false)}>
    <div
      className="insufficient-modal"
      onClick={e => e.stopPropagation()}
    >
      {/* ─── Coin ─── */}
      <div className="insufficient-coin">
        <div className="pl__coin">
          <div className="pl__coin-flare"></div>
          <div className="pl__coin-flare"></div>
          <div className="pl__coin-flare"></div>
          <div className="pl__coin-flare"></div>
          <div className="pl__coin-layers">
            <div className="pl__coin-layer">
              <div className="pl__coin-inscription"></div>
            </div>
            <div className="pl__coin-layer"></div>
            <div className="pl__coin-layer"></div>
            <div className="pl__coin-layer"></div>
            <div className="pl__coin-layer">
              <div className="pl__coin-inscription"></div>
            </div>
          </div>
        </div>
        <div className="pl__shadow"></div>
      </div>

      {/* ─── Text ─── */}
      <h2>Insufficient credits</h2>
      <p>Please upgrade your plan to add more credits.</p>

      {/* ─── Continue Button ─── */}
      <button
        className="insufficient-cta"
        onClick={() => {
          setShowInsufficient(false);
          openManagePlan();
        }}
      >
        Continue
      </button>
    </div>
  </div>
)}

{tutorialModalOpen && (
  <div className="tutorial-modal-backdrop" onClick={closeTutorialModal}>
    <div className="tutorial-modal" onClick={e => e.stopPropagation()}>
      <div className="tutorial-video-wrapper">
        <video
          src={ tutorialToPlay === "95" ? editvibe95tutorial : editvibecuttutorial }
          controls
          className="tutorial-video"
        />
      </div>
      <div className="tutorial-footer">
        <h3 className="tutorial-title">
          {tutorialToPlay === "95"
            ? "EditVibe‑95 Tutorial"
            : "EditVibe‑CUT Tutorial"}
        </h3>
        <button
          className="tutorial-close-btn"
          onClick={closeTutorialModal}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

{showKillModal && (
    <div className="overlay" onClick={() => setShowKillModal(false)}>
      <div
        className="kill-switch-modal"
        onClick={e => e.stopPropagation()}
      >
        <AiOutlineHistory size={48} className="kill-icon" />
        <p>
          EditVibe AI is being delayed as we are experiencing a rapid increase<br/>
          in users using the service. We apologize for the inconvenience.<br/>
          Please try again later.
        </p>
        <button
          className="continue-btn"
          onClick={() => setShowKillModal(false)}
        >
          CONTINUE
        </button>
      </div>
    </div>
  )}

</div>
    </>
  );
}

export default EditVibeLayout;
